export const SUBS_LIMITS = {
  flipper: {
    default: 50000,
    normal: 100000,
    outstanding: 350000,
    masterpiece: 2147483647
  },
  tradeRoutes: {
    maxProfitPerKg: {
      default: 100,
      normal: 500,
      outstanding: 1000,
      masterpiece: 2147483647
    },
    maxProfitPercentage: {
      default: 0.15,
      normal: 0.50,
      outstanding: 1,
      masterpiece: 2147483647
    }
  }
} as const;